module.exports = __webpack_public_path__ + "static/media/disabled_toilet.d168ee0f.svg";